import { createCube } from './createCube.js';

export const cubePages = [
  // PAGE 1
  {
    facesGuide: [
      createCube(
        'G',
        {
          1: 'Y',
          2: 'Y',
          3: 'Y',
        },
        {
          1: 'R',
          2: 'R',
          3: 'R',
        },
        'U (UP)'
      ),

      createCube(
        'X',
        {
          7: 'Y',
          8: 'Y',
          9: 'Y',
        },
        {
          7: 'R',
          8: 'R',
          9: 'R',
        },
        'D (DOWN)'
      ),

      createCube(
        {
          1: 'G',
          4: 'G',
          7: 'G',
        },
        {
          1: 'Y',
          4: 'Y',
          7: 'Y',
        },
        'X',
        'L (LEFT)'
      ),

      createCube(
        {
          3: 'G',
          6: 'G',
          9: 'G',
        },
        {
          3: 'Y',
          6: 'Y',
          9: 'Y',
        },
        'R',
        'R (RIGHT)'
      ),

      createCube(
        {
          7: 'G',
          8: 'G',
          9: 'G',
        },
        'Y',
        {
          1: 'R',
          4: 'R',
          7: 'R',
        },
        'F (FRONT)'
      ),

      createCube(
        {
          1: 'G',
          2: 'G',
          3: 'G',
        },
        'X',
        {
          3: 'R',
          6: 'R',
          9: 'R',
        },
        'B (BACK)'
      ),
    ],

    faceWithCentralCubes: [
      createCube(
        {
          5: 'B',
        },
        {
          5: 'R',
        },
        {
          5: 'Y',
        }
      ),
    ],
    faceWithCross: [
      createCube(
        {
          2: 'B',
          4: 'B',
          5: 'B',
          6: 'B',
          8: 'B',
        },
        {
          2: 'R',
          5: 'R',
        },
        {
          2: 'Y',
          5: 'Y',
        }
      ),
    ],
  },

  // PAGE 2
  {
    faceCornerPos1: [
      createCube(
        {
          2: 'B',
          4: 'B',
          5: 'B',
          6: 'B',
          8: 'B',
        },
        {
          2: 'R',
          5: 'R',
          9: 'B',
        },
        {
          2: 'Y',
          5: 'Y',
          7: 'Y',
        }
      ),
    ],
    faceCornerPos2: [
      createCube(
        {
          2: 'B',
          4: 'B',
          5: 'B',
          6: 'B',
          8: 'B',
        },
        {
          2: 'R',
          5: 'R',
          9: 'Y',
        },
        {
          2: 'Y',
          5: 'Y',
          7: 'R',
        }
      ),
    ],
    faceCornerPos3: [
      createCube(
        {
          2: 'B',
          4: 'B',
          5: 'B',
          6: 'B',
          8: 'B',
        },
        {
          2: 'R',
          5: 'R',
          9: 'R',
        },
        {
          2: 'Y',
          5: 'Y',
          7: 'B',
        }
      ),
    ],
    faceCornerPos4: [
      createCube(
        {
          2: 'B',
          4: 'B',
          5: 'B',
          6: 'B',
          8: 'B',
          9: 'R',
        },
        {
          2: 'R',
          3: 'Y',
          5: 'R',
        },
        {
          1: 'B',
          2: 'Y',
          5: 'Y',
        }
      ),
    ],
    faceCornerPos5: [
      createCube(
        {
          2: 'B',
          4: 'B',
          5: 'B',
          6: 'B',
          8: 'B',
          9: 'Y',
        },
        {
          2: 'R',
          3: 'B',
          5: 'R',
        },
        {
          2: 'Y',
          1: 'R',
          5: 'Y',
        }
      ),
    ],
    faceCornerPos6: [
      createCube(
        {
          2: 'B',
          4: 'B',
          5: 'B',
          6: 'B',
          8: 'B',
          9: 'B',
        },
        {
          2: 'R',
          3: 'R',
          5: 'R',
        },
        {
          2: 'Y',
          1: 'Y',
          5: 'Y',
        }
      ),
    ],
  },
  // PAGE 3
  {
    middleLayerCase1: [
      createCube(
        {
          5: 'G',
          8: 'W',
        },
        {
          2: 'R',
          5: 'R',
          7: 'R',
          8: 'R',
          9: 'R',
        },
        {
          5: 'W',
          7: 'W',
          8: 'W',
          9: 'W',
        }
      ),
    ],
    middleLayerCase2: [
      createCube(
        {
          5: 'G',
          8: 'W',
          9: 'W',
        },
        {
          2: 'R',
          3: 'R',
          5: 'R',
          7: 'R',
          8: 'R',
        },
        {
          1: 'B',
          5: 'W',
          8: 'W',
          9: 'W',
        }
      ),
    ],
    middleLayerCase3: [
      createCube(
        {
          5: 'G',
        },
        {
          5: 'R',
          6: 'R',
          7: 'R',
          8: 'R',
          9: 'R',
        },
        {
          4: 'W',
          5: 'W',
          7: 'W',
          8: 'W',
          9: 'W',
        }
      ),
    ],

    middleLayerCase4: [
      createCube(
        {
          5: 'G',
          6: 'R',
        },
        {
          5: 'R',
          7: 'R',
          8: 'R',
          9: 'R',
        },
        {
          2: 'W',
          5: 'W',
          7: 'W',
          8: 'W',
          9: 'W',
        }
      ),
    ],
    middleLayerCase5: [
      createCube(
        {
          5: 'G',
          6: 'R',
          9: 'R',
        },
        {
          3: 'B',
          5: 'R',
          7: 'R',
          8: 'R',
        },
        {
          1: 'W',
          2: 'W',
          5: 'W',
          8: 'W',
          9: 'W',
        }
      ),
    ],
    middleLayerWrongEdge: [
      createCube(
        {
          5: 'G',
        },
        {
          5: 'R',
          6: 'W',
          7: 'R',
          8: 'R',
          9: 'R',
        },
        {
          4: 'R',
          5: 'W',
          7: 'W',
          8: 'W',
          9: 'W',
        }
      ),
    ],
  },
  // Page 4
  {
    topCrossCase1: [
      createCube(
        {
          5: 'G',
        },
        {
          4: 'W',
          5: 'W',
          6: 'W',
          7: 'W',
          8: 'W',
          9: 'W',
        },
        {
          4: 'O',
          5: 'O',
          6: 'O',
          7: 'O',
          8: 'O',
          9: 'O',
        }
      ),
    ],
    topCrossCase2: [
      createCube(
        {
          2: 'G',
          4: 'G',
          5: 'G',
        },
        {
          4: 'W',
          5: 'W',
          6: 'W',
          7: 'W',
          8: 'W',
          9: 'W',
        },
        {
          4: 'O',
          5: 'O',
          6: 'O',
          7: 'O',
          8: 'O',
          9: 'O',
        }
      ),
    ],
    topCrossCase3: [
      createCube(
        {
          4: 'G',
          5: 'G',
          6: 'G',
        },
        {
          4: 'W',
          5: 'W',
          6: 'W',
          7: 'W',
          8: 'W',
          9: 'W',
        },
        {
          4: 'O',
          5: 'O',
          6: 'O',
          7: 'O',
          8: 'O',
          9: 'O',
        }
      ),
    ],
    topCrossCase4: [
      createCube(
        {
          2: 'G',
          5: 'G',
          8: 'G',
        },
        {
          4: 'W',
          5: 'W',
          6: 'W',
          7: 'W',
          8: 'W',
          9: 'W',
        },
        {
          4: 'O',
          5: 'O',
          6: 'O',
          7: 'O',
          8: 'O',
          9: 'O',
        }
      ),
    ],
    topCrossCase5: [
      createCube(
        {
          5: 'G',
          6: 'G',
          8: 'G',
        },
        {
          4: 'W',
          5: 'W',
          6: 'W',
          7: 'W',
          8: 'W',
          9: 'W',
        },
        {
          4: 'O',
          5: 'O',
          6: 'O',
          7: 'O',
          8: 'O',
          9: 'O',
        }
      ),
    ],
    topCrossSolved: [
      createCube(
        {
          2: 'G',
          4: 'G',
          5: 'G',
          6: 'G',
          8: 'G',
        },
        {
          4: 'W',
          5: 'W',
          6: 'W',
          7: 'W',
          8: 'W',
          9: 'W',
        },
        {
          4: 'O',
          5: 'O',
          6: 'O',
          7: 'O',
          8: 'O',
          9: 'O',
        }
      ),
    ],
    topCrossAdjacent: [
      createCube(
        {
          2: 'G',
          5: 'G',
          6: 'G',
        },
        {
          4: 'W',
          5: 'W',
          6: 'W',
          7: 'W',
          8: 'W',
          9: 'W',
        },
        {
          2: 'O',
          4: 'O',
          5: 'O',
          6: 'O',
          7: 'O',
          8: 'O',
          9: 'O',
        }
      ),
    ],
    topCrossOriented: [
      createCube(
        {
          2: 'G',
          4: 'G',
          5: 'G',
          6: 'G',
          8: 'G',
        },
        {
          2: 'W',
          4: 'W',
          5: 'W',
          6: 'W',
          7: 'W',
          8: 'W',
          9: 'W',
        },
        {
          2: 'O',
          4: 'O',
          5: 'O',
          6: 'O',
          7: 'O',
          8: 'O',
          9: 'O',
        }
      ),
    ],
  },
  // Page 5
  {
    cornerSwapCase1: [
      createCube(
        {
          1: 'G',
          2: 'G',
          3: 'W',
          4: 'G',
          5: 'G',
          6: 'G',
          7: 'O',
          8: 'G',
          9: 'Y',
        },
        {
          1: 'G',
          2: 'O',
          3: 'R',
          4: 'O',
          5: 'O',
          6: 'O',
          7: 'O',
          8: 'O',
          9: 'O',
        },
        {
          1: 'G',
          2: 'Y',
          3: 'O',
          4: 'Y',
          5: 'Y',
          6: 'Y',
          7: 'Y',
          8: 'Y',
          9: 'Y',
        }
      ),
    ],
    cornerSwapCase2: [
      createCube(
        {
          1: 'W',
          2: 'G',
          3: 'R',
          4: 'O',
          5: 'G',
          6: 'R',
          7: 'W',
          8: 'W',
          9: 'O',
        },
        {
          1: 'B',
          2: 'B',
          3: 'Y',
          4: 'O',
          5: 'O',
          6: 'G',
          7: 'O',
          8: 'O',
          9: 'Y',
        },
        {
          1: 'G',
          2: 'Y',
          3: 'Y',
          4: 'Y',
          5: 'Y',
          6: 'Y',
          7: 'G',
          8: 'Y',
          9: 'Y',
        }
      ),
    ],
    cornerSwapCase3: [
      createCube(
        {
          1: 'G',
          2: 'G',
          3: 'Y',
          4: 'G',
          5: 'G',
          6: 'G',
          7: 'Y',
          8: 'G',
          9: 'G',
        },
        {
          1: 'G',
          2: 'O',
          3: 'W',
          4: 'O',
          5: 'O',
          6: 'O',
          7: 'O',
          8: 'O',
          9: 'O',
        },
        {
          1: 'O',
          2: 'Y',
          3: 'R',
          4: 'Y',
          5: 'Y',
          6: 'Y',
          7: 'Y',
          8: 'Y',
          9: 'Y',
        }
      ),
    ],
    cornerSwapCase4: [
      createCube(
        {
          1: 'O',
          2: 'G',
          3: 'O',
          4: 'G',
          5: 'G',
          6: 'G',
          7: 'R',
          8: 'G',
          9: 'R',
        },
        {
          1: 'Y',
          2: 'R',
          3: 'W',
          4: 'R',
          5: 'R',
          6: 'R',
          7: 'R',
          8: 'R',
          9: 'R',
        },
        {
          1: 'G',
          2: 'W',
          3: 'G',
          4: 'W',
          5: 'W',
          6: 'W',
          7: 'W',
          8: 'W',
          9: 'W',
        }
      ),
    ],
    cornerSwapCase5: [
      createCube(
        {
          1: 'O',
          2: 'G',
          3: 'O',
          4: 'G',
          5: 'G',
          6: 'G',
          7: 'R',
          8: 'G',
          9: 'W',
        },
        {
          1: 'Y',
          2: 'R',
          3: 'G',
          4: 'R',
          5: 'R',
          6: 'R',
          7: 'B',
          8: 'B',
          9: 'B',
        },
        {
          1: 'R',
          2: 'W',
          3: 'G',
          4: 'B',
          5: 'W',
          6: 'W',
          7: 'R',
          8: 'W',
          9: 'O',
        }
      ),
    ],
    cornerSwapCase6: [
      createCube(
        {
          1: 'O',
          2: 'G',
          3: 'O',
          4: 'G',
          5: 'G',
          6: 'G',
          7: 'R',
          8: 'G',
          9: 'G',
        },
        {
          1: 'Y',
          2: 'R',
          3: 'R',
          4: 'R',
          5: 'R',
          6: 'B',
          7: 'Y',
          8: 'R',
          9: 'W',
        },
        {
          1: 'W',
          2: 'W',
          3: 'G',
          4: 'W',
          5: 'W',
          6: 'W',
          7: 'B',
          8: 'B',
          9: 'B',
        }
      ),
    ],
    cornerSwapCase7: [
      createCube(
        {
          1: 'R',
          2: 'G',
          3: 'O',
          4: 'G',
          5: 'G',
          6: 'G',
          7: 'G',
          8: 'G',
          9: 'O',
        },
        {
          1: 'W',
          2: 'W',
          3: 'G',
          4: 'R',
          5: 'R',
          6: 'B',
          7: 'Y',
          8: 'R',
          9: 'W',
        },
        {
          1: 'W',
          2: 'O',
          3: 'Y',
          4: 'W',
          5: 'W',
          6: 'W',
          7: 'B',
          8: 'B',
          9: 'B',
        }
      ),
    ],
    cornerSwapCase8: [
      createCube(
        {
          1: 'R',
          2: 'G',
          3: 'O',
          4: 'G',
          5: 'G',
          6: 'G',
          7: 'G',
          8: 'G',
          9: 'W',
        },
        {
          1: 'W',
          2: 'W',
          3: 'O',
          4: 'R',
          5: 'R',
          6: 'R',
          7: 'B',
          8: 'B',
          9: 'B',
        },
        {
          1: 'G',
          2: 'O',
          3: 'Y',
          4: 'B',
          5: 'W',
          6: 'W',
          7: 'R',
          8: 'W',
          9: 'O',
        }
      ),
    ],
    cornerSwapCase9: [
      createCube(
        {
          1: 'R',
          2: 'G',
          3: 'O',
          4: 'G',
          5: 'G',
          6: 'G',
          7: 'G',
          8: 'G',
          9: 'G',
        },
        {
          1: 'W',
          2: 'W',
          3: 'W',
          4: 'R',
          5: 'R',
          6: 'R',
          7: 'R',
          8: 'R',
          9: 'R',
        },
        {
          1: 'O',
          2: 'O',
          3: 'Y',
          4: 'W',
          5: 'W',
          6: 'W',
          7: 'W',
          8: 'W',
          9: 'W',
        }
      ),
    ],
    cornerSwapCase10: [
      createCube(
        {
          1: 'G',
          2: 'G',
          3: 'R',
          4: 'G',
          5: 'G',
          6: 'G',
          7: 'G',
          8: 'G',
          9: 'O',
        },
        {
          1: 'O',
          2: 'O',
          3: 'Y',
          4: 'R',
          5: 'R',
          6: 'R',
          7: 'R',
          8: 'R',
          9: 'R',
        },
        {
          1: 'G',
          2: 'Y',
          3: 'G',
          4: 'W',
          5: 'W',
          6: 'W',
          7: 'W',
          8: 'W',
          9: 'W',
        }
      ),
    ],
    cornerSwapCase11: [
      createCube(
        {
          1: 'G',
          2: 'G',
          3: 'R',
          4: 'G',
          5: 'G',
          6: 'G',
          7: 'G',
          8: 'G',
          9: 'Y',
        },
        {
          1: 'O',
          2: 'O',
          3: 'G',
          4: 'R',
          5: 'R',
          6: 'R',
          7: 'B',
          8: 'B',
          9: 'B',
        },
        {
          1: 'O',
          2: 'Y',
          3: 'G',
          4: 'B',
          5: 'W',
          6: 'W',
          7: 'R',
          8: 'W',
          9: 'O',
        }
      ),
    ],
    cornerSwapCase12: [
      createCube(
        {
          1: 'G',
          2: 'G',
          3: 'R',
          4: 'G',
          5: 'G',
          6: 'G',
          7: 'G',
          8: 'G',
          9: 'G',
        },
        {
          1: 'O',
          2: 'O',
          3: 'O',
          4: 'R',
          5: 'R',
          6: 'B',
          7: 'Y',
          8: 'R',
          9: 'W',
        },
        {
          1: 'Y',
          2: 'Y',
          3: 'G',
          4: 'W',
          5: 'W',
          6: 'W',
          7: 'B',
          8: 'B',
          9: 'B',
        }
      ),
    ],
    cornerSwapCase13: [
      createCube(
        {
          1: 'G',
          2: 'G',
          3: 'G',
          4: 'G',
          5: 'G',
          6: 'G',
          7: 'G',
          8: 'G',
          9: 'R',
        },
        {
          1: 'Y',
          2: 'Y',
          3: 'G',
          4: 'R',
          5: 'R',
          6: 'B',
          7: 'Y',
          8: 'R',
          9: 'W',
        },
        {
          1: 'Y',
          2: 'R',
          3: 'R',
          4: 'W',
          5: 'W',
          6: 'W',
          7: 'B',
          8: 'B',
          9: 'B',
        }
      ),
    ],
    cornerSwapCase14: [
      createCube(
        {
          1: 'G',
          2: 'G',
          3: 'G',
          4: 'G',
          5: 'G',
          6: 'G',
          7: 'G',
          8: 'G',
          9: 'Y',
        },
        {
          1: 'Y',
          2: 'Y',
          3: 'R',
          4: 'R',
          5: 'R',
          6: 'R',
          7: 'B',
          8: 'B',
          9: 'B',
        },
        {
          1: 'G',
          2: 'R',
          3: 'R',
          4: 'B',
          5: 'W',
          6: 'W',
          7: 'R',
          8: 'W',
          9: 'O',
        }
      ),
    ],
    cornerSwapCase15: [
      createCube(
        {
          1: 'G',
          2: 'G',
          3: 'G',
          4: 'G',
          5: 'G',
          6: 'G',
          7: 'G',
          8: 'G',
          9: 'G',
        },
        {
          1: 'Y',
          2: 'Y',
          3: 'Y',
          4: 'R',
          5: 'R',
          6: 'R',
          7: 'R',
          8: 'R',
          9: 'R',
        },
        {
          1: 'R',
          2: 'R',
          3: 'R',
          4: 'W',
          5: 'W',
          6: 'W',
          7: 'W',
          8: 'W',
          9: 'W',
        }
      ),
    ],
    cornerSwapCase16: [createCube('G', 'R', 'W', 'Solved')],
  },
];
